import { useState } from 'react';

import NavBar from '../navbar';

import './Contact.css';

const ContactComponent = () => {
    const [name, setName] = useState('');
    const [subject, setSubject] = useState('');
    const [text, setText] = useState('');
    const mailSubject = encodeURIComponent(subject || 'Portfolio contact');
    const mailBody = encodeURIComponent(`${name ? `${name} | ` : ''}${text}`);
    const mailTo = `mailto:nathanrheinz@gmail.com?subject=${mailSubject}&body=${mailBody}`;
    
    
    return (
        <div>
            <NavBar />
            
            <div id='contact-main-container'>
                <div id='contact-content-container'>
                    <div className='contact-heading'>
                        <span>05 / CONTACT</span>
                        <h2>Contact Me</h2>
                        <p>Send a quick note and your email client will open with the message ready to go.</p>
                    </div>
                    
                    <div id='contact-form-container'>
                        
                        <input className='contact-form-input'
                            type='text' 
                            placeholder='Your Name'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        
                        <input className='contact-form-input2'
                            type='text' 
                            placeholder='Subject'
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                        
                        <textarea id='contact-form-textarea'
                            placeholder='What would you like to say?'
                            minLength={10}
                            maxLength={250}
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        />
                        
                        <a href={mailTo}
                            id='contact-form-button'
                        >Send message <i className="fa-solid fa-paper-plane" />
                        </a>
                        
                    </div>
                    
                    
                </div>
            </div>
            
        </div>
    );
};

export default ContactComponent;
